import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getOrderDetailsRequest } from '../../api/Owner/order/getOrderDetailsQuery/getOrderDetailsQuery';
import { searchFailedOrdersRequest } from '../../api/Owner/searchFailedOrdersQuery';
import { logVerbose } from '../../configuration';

import {
  LOAD_FAILED_ORDERS,
  LOAD_MARKETPLACE_DETAILED_ORDER,
} from './actionTypes';

function* loadMarketplaceDetailedOrderWorker({ payload: orderId }) {
  if (!orderId) {
    logVerbose(new Error('Trying to load order details with a null orderId'));

    return;
  }

  yield executeSagaRequest(
    LOAD_MARKETPLACE_DETAILED_ORDER,
    getOrderDetailsRequest({ orderId }),
    {
      indexer: orderId,
      orderId,
    },
  );
  yield put(LOAD_MARKETPLACE_DETAILED_ORDER.end());
}
function* loadMarketplaceDetailedOrderWatcher() {
  yield takeEvery(
    LOAD_MARKETPLACE_DETAILED_ORDER.BASE,
    loadMarketplaceDetailedOrderWorker,
  );
}

function* loadFailedOrdersWorker({ payload: searchQuery }) {
  yield executeSagaRequest(
    LOAD_FAILED_ORDERS,
    searchFailedOrdersRequest({ searchQuery }),
    {
      searchQuery,
    },
  );
  yield put(LOAD_FAILED_ORDERS.end());
}
function* loadFailedOrdersWatcher() {
  yield takeEvery(LOAD_FAILED_ORDERS.BASE, loadFailedOrdersWorker);
}

export default function* mainSaga() {
  try {
    yield all([
      loadMarketplaceDetailedOrderWatcher(),
      loadFailedOrdersWatcher(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
